// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doughnut{width:100%;height:100%}.doughnut-container{position:relative;height:150px;width:150px}@media(max-width:399px){.doughnut-container{width:120px;height:120px}}.doughnut-label{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;font-size:29px;font-weight:700;z-index:0}@media(max-width:399px){.doughnut-label{font-size:25px}}.doughnut-sublabel{font-size:14px;font-weight:700}@media(max-width:399px){.doughnut-sublabel{font-size:12px}}", ""]);
// Exports
module.exports = exports;
